var Education = "Giáo dục";
var Enterprise = "Doanh nghiệp";
var CompanyType = {
	"Company type": "Loại hình công ty",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Chính phủ - Liên bang",
	"Government - State & local": "Chính phủ - Tiểu bang & Địa phương",
	"Non-profit": "Phi lợi nhuận",
	"Self employed": "Tự kinh doanh",
	"Small-medium business": "Doanh nghiệp vừa và nhỏ ",
	"Start-up": "Doanh nghiệp khởi nghiệp",
	"Not applicable": "Không có đáp án nào phù hợp"
};

export { Education, Enterprise, CompanyType as default };
